__turbopack_context__.v({
  "scrollToTopContainer": "styles-module-scss-module__oZE4Fa__scrollToTopContainer",
  "scrollToTopContainerOpen": "styles-module-scss-module__oZE4Fa__scrollToTopContainerOpen",
});
